import { render } from "./MyMobileNavMenu.vue?vue&type=template&id=00b8a4be"
import script from "./MyMobileNavMenu.vue?vue&type=script&lang=js"
export * from "./MyMobileNavMenu.vue?vue&type=script&lang=js"

import "./MyMobileNavMenu.vue?vue&type=style&index=0&id=00b8a4be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__